import homeActive from '@/presentation/assets/tabbar/home-active.svg'
import homeInactive from '@/presentation/assets/tabbar/home-inactive.svg'
import inviteActive from '@/presentation/assets/tabbar/invite-active.svg'
import inviteInactive from '@/presentation/assets/tabbar/invite-inactive.svg'
import meActive from '@/presentation/assets/tabbar/me-active.svg'
import meInactive from '@/presentation/assets/tabbar/me-inactive.svg'
import teamActive from '@/presentation/assets/tabbar/team-active.svg'
import teamInactive from '@/presentation/assets/tabbar/team-inactive.svg'

interface IconProps {
  active: boolean
}

/**
 * Home 图标
 * @param props {IconProps}
 */
export const HomeIcon = (props: IconProps) => (
  <img
    src={props.active ? homeActive : homeInactive}
    alt='Home'
    className='size-full block'
  />
)

/**
 * Invite 图标
 * @param props {IconProps}
 */
export const InviteIcon = (props: IconProps) => (
  <img
    src={props.active ? inviteActive : inviteInactive}
    alt='Invite'
    className='size-full block'
  />
)

/**
 * Team 图标
 * @param props {IconProps}
 */
export const TeamIcon = (props: IconProps) => (
  <img
    src={props.active ? teamActive : teamInactive}
    alt='Team'
    className='size-full block'
  />
)

/**
 * Me 图标
 * @param props {IconProps}
 */
export const MeIcon = (props: IconProps) => (
  <img
    src={props.active ? meActive : meInactive}
    alt='Me'
    className='size-full block'
  />
)
